import { Box, Flex, Text } from '@chakra-ui/react';
import { ChevronRight } from 'react-feather';

export const CurrentStatus = ({
  title,
  lastUpdated,
  text,
}: {
  title: string;
  lastUpdated: string;
  text: string;
}): JSX.Element => {
  return (
    <Flex
      direction="row"
      background="custom.levoWhite"
      borderStyle="solid"
      borderColor="custom.containerBg"
      borderLeftWidth="16px"
      borderLeftColor="custom.levoBlue"
      boxSizing="border-box"
      borderRadius="10px"
      mb={4}
    >
      <Flex direction="row" p={4}>
        <Flex direction="column">
          <Text textStyle="body" fontWeight={700} mb={1}>
            {title}
          </Text>
          <Text
            textStyle="preTitle"
            fontStyle="italic"
            fontWeight={400}
            color="custom.levoLightBlack"
            mb={2}
          >
            Last updated: {lastUpdated}
          </Text>
          <Text textStyle="body" color="custom.levoLightBlack">
            {text}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export const StatusTask = ({
  title,
  description,
  url,
  action,
  completed,
  upcoming,
  handleAction,
}: {
  title: string;
  description: string;
  url?: string;
  action?: string;
  completed?: boolean;
  upcoming?: boolean;
  handleAction: (action: string) => void;
}): JSX.Element => {
  const handleClick = () => {
    if (url) {
      window.open(url);
    }
    if (action) {
      handleAction(action);
    }
  };

  return (
    <Flex
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      background="custom.levoWhite"
      boxSizing="border-box"
      borderRadius="10px"
      cursor={!!url ? 'pointer' : 'default'}
      as={!!url ? 'button' : 'div'}
      p={4}
      mb={4}
      onClick={!!url || !!action ? handleClick : undefined}
    >
      <Flex direction="row" pl={completed ? 0 : 4}>
        {completed && (
          <Box
            display="inline-block"
            borderRadius="50%"
            height="10px"
            width="10px"
            bg={completed ? 'custom.levoBlue' : 'transparent'}
            mr={1}
            mt="6px"
          />
        )}
        <Flex direction="column" alignItems="flex-start">
          <Text
            textStyle="body"
            fontWeight={700}
            mb={1}
            color={upcoming ? 'custom.levoLightBlack' : ''}
          >
            {title}
          </Text>
          <Text textStyle="body" color="custom.levoLightBlack">
            {description}
          </Text>
        </Flex>
      </Flex>
      {(!!url || !!action) && (
        <Flex>
          <ChevronRight />
        </Flex>
      )}
    </Flex>
  );
};

export const UpcomingStatus = ({
  title,
  text,
  next,
}: {
  title: string;
  text: string;
  next?: boolean;
}): JSX.Element => {
  return (
    <Flex
      direction="row"
      background="custom.levoWhite"
      boxSizing="border-box"
      borderRadius="10px"
      mb={4}
    >
      <Flex direction="column" p={4} pl={8}>
        <Text
          textStyle="body"
          fontWeight={700}
          color={next ? '' : 'custom.levoLightBlack'}
          mb={1}
        >
          {title}
        </Text>
        <Text textStyle="body" color="custom.levoLightBlack">
          {text}
        </Text>
      </Flex>
    </Flex>
  );
};
